var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99951 10C10.3802 10 11.4995 8.88071 11.4995 7.5C11.4995 6.11929 10.3802 5 8.99951 5C7.6188 5 6.49951 6.11929 6.49951 7.5C6.49951 8.88071 7.6188 10 8.99951 10Z",
    fill: "#4C4C4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.102354 7.03891C1.34173 3.31309 4.85611 0.625 8.99994 0.625C13.1419 0.625 16.6549 3.3106 17.8958 7.03371C17.9961 7.3346 17.9962 7.66015 17.8961 7.96109C16.6567 11.6869 13.1423 14.375 8.99848 14.375C4.85657 14.375 1.34354 11.6894 0.102627 7.96629C0.00234258 7.66541 0.00224714 7.33986 0.102354 7.03891ZM13.3745 7.5C13.3745 9.91625 11.4158 11.875 8.99951 11.875C6.58327 11.875 4.62451 9.91625 4.62451 7.5C4.62451 5.08375 6.58327 3.125 8.99951 3.125C11.4158 3.125 13.3745 5.08375 13.3745 7.5Z",
    fill: "#4C4C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.53a7439d108361ab867730a5c170a287.svg";
export { ForwardRef as ReactComponent };